import MinimarLogo from "@/components/MinimarLogo/MinimarLogo";
import clsx from "clsx";
import { Link, useLocation } from "react-router-dom";
import LocaleSelector from "./LocaleSelector";
import React, { useEffect } from "react";
import useFetchApi from "@/api/hooks/useFetchApi";
import { useMutateApi } from "@/api/hooks/useMutateApi";


const Header: React.FC = () => {
    const [dataWithRelated, setDataWithRelated] = React.useState<any[]>([]);
    const location = useLocation();

    const {
        data,
        isLoading
    } = useFetchApi({
        url: "/v1/pages",
        service: "CMS_PROC"
    });

    const {
        _get
    } = useMutateApi({
        Service: "CMS_PROC"
    });

    async function fetchData() {
        let tmp = data?.filter((x: any) => !x.tags?.includes("no-nav"));
        // for render tags
        for (let i = 0; i < tmp?.length; i++) {
            let tags = tmp[i].tags;
            let related = tags?.filter((x: string) => x.includes("render;"));
            let target_data = null;
            if (related && related.length > 0) {
                target_data = await _get("/v1/page/" + tmp[i].slug + "?response=json");
            }
            tmp[i].target_data = target_data?.data;
        }

        setDataWithRelated(
            tmp || []
        );
    }

    useEffect(() => {
        fetchData();
    }, [data]);

    return (
        <header id="header" className="medicom-header medical-nav">

            <div className="solid-row"></div>

            <div className="container">



                <nav className="navbar navbar-default" role="navigation">



                    <div className="navbar-header">

                        <button type="button" className="navbar-toggle" data-toggle="collapse" data-target="#primary-nav">
                            <span className="sr-only">Toggle navigation</span>
                            <span className="icon-bar"></span>
                            <span className="icon-bar"></span>
                            <span className="icon-bar"></span>
                        </button>

                        <Link className="navbar-brand" to="/"><MinimarLogo size="header" /></Link>

                    </div>


                    <div className="collapse navbar-collapse navbar-right" id="primary-nav">

                        <ul className="nav navbar-nav">

                            {dataWithRelated?.map((member: any, index: number) => {
                                return (

                                    <li className={clsx("dropdown",
                                        member.slug === location.pathname ? "active" : ""
                                    )} key={"nav-el-" + index}>
                                        <Link
                                            to={
                                                member.tags?.includes("no-link") ? "#" : member.slug
                                            }
                                            className="dropdown-toggle" data-toggle="dropdown"><i
                                                className="fa fa-plus"></i>
                                            {member.name}
                                            {member.tags?.filter((x: string) => x.includes("render;"))?.map((x: any) => {
                                                let parts = x.split(";");
                                                let target_url_template = parts[1];
                                                let target_module = parts[2];
                                                let target_module_field = parts[3];
                                                const target_data = member.target_data;
                                                return (
                                                    <ul className="dropdown-menu" style={{ marginTop: -3 }}>
                                                        {target_data && target_data[target_module]?.map((m: any, mi: number) => {
                                                            return (
                                                                <li key={"nav-el-" + index}>
                                                                    <Link to={
                                                                        target_url_template.replace(target_url_template.split("/").find((x: string) => x.startsWith(":")), m[target_module_field])

                                                                    }>{m.title}</Link>
                                                                </li>
                                                            )
                                                        })}
                                                    </ul>
                                                )
                                            })}
                                        </Link>
                                    </li>
                                )
                            })}
                            <li
                                style={{
                                    display: "none"
                                }}
                                className="dropdown last">
                                <LocaleSelector />
                            </li>
                        </ul>
                    </div>
                </nav>
            </div>
        </header>
    );
};

export default Header;